var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,_vm._b({tag:"component",class:_vm.buttonClasses,attrs:{"href":_vm.href,"disabled":_vm.disabled}},'component',_vm.$attrs,false),[_c('span',{staticClass:"btn-text link-text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }